import MemberGymForm from '@/view/forms/member-gym-form'
import { useCashfitParams } from '@/view/hooks/use-params'
import { CardInfoSelectMember } from '../../components/card-info-select-member'
import { Tabs, TabsList, TabsTrigger } from '../../components/ui/tabs'
import { DisplayMemberGym } from '../dashboard-owner-gym/panels/display-member-gym'
import ContractTab from './contract-tab'
import OverviewTab from './overview-tab'
import PaymentsTab from './payments-tab'
import SellTab from './sell/sell-tab'
import ContractForm from './contract-edit-tab'

type Tabs = 'studants' | 'overview' | 'register-member' | 'sell' | 'payments' | 'contract'

export default function MemberPage() {
  const { getParam, setParams } = useCashfitParams<Tabs>({
    navId: '3',
    tabSelected: 'studants'
  })

  const tab = getParam('tabSelected')

  return (
    <div className="w-full h-full flex flex-col gap-6">
      <div className="grid grid-cols-[300px_1fr] items-center justify-center">
        <span className="flex items-center gap-4 font-bold text-xl">Alunos</span>
        <div className="flex items-center justify-end">
          <Tabs
            defaultValue={getParam('tabSelected') || 'studants'}
            value={getParam('tabSelected') || 'studants'}
            // onClick={() => {
            //   removeParam('tabContentId')
            //   removeParam('formId')
            // }}
            onValueChange={(value) => {
              setParams({
                tabSelected: value as keyof Tabs
              })
            }}
          >
            <TabsList>
              <TabsTrigger value="studants" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                Alunos
              </TabsTrigger>
              <TabsTrigger value="overview" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                Visão Geral
              </TabsTrigger>
              <TabsTrigger value="register-member" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                Cadastro
              </TabsTrigger>
              <TabsTrigger value="sell" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                Venda
              </TabsTrigger>
              <TabsTrigger value="payments" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                Pagamento
              </TabsTrigger>
              <TabsTrigger value="contract" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                Contrato
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </div>

      {tab == 'studants' && <DisplayMemberGym />}

      {tab == 'overview' && <OverviewTab id={getParam('tabContentId') || ''} />}

      {tab == 'register-member' && <MemberGymForm id={getParam('tabContentId') || ''} />}

      {tab == 'sell' && (
        <>{getParam('tabContentId') || false ? <SellTab externalMemberSelected={null} /> : <CardInfoSelectMember backToStudents={() => setParams({ tabSelected: 'studants' as any })} />}</>
      )}

      {tab == 'payments' && <PaymentsTab id={getParam('tabContentId')} />}

      {tab == 'contract' && !getParam('tabPlanId') && <ContractTab id={getParam('tabContentId')} idUnidade={getParam('unit')} />}

      {(tab == 'contract' && getParam('tabPlanId')) && <ContractForm idAluno={getParam('tabContentId')} idPlano={getParam('tabPlanId')} />}


    </div>
  )
}
